import { render, staticRenderFns } from "./ComponentGroupForm.vue?vue&type=template&id=4624175e&scoped=true"
import script from "./ComponentGroupForm.vue?vue&type=script&lang=js"
export * from "./ComponentGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4624175e",
  null
  
)

export default component.exports